import channelsApi from '../../api/channel'
import localforageKeys from '../../helper/localForageKeys'

export const CLEAR_BOTS_STORE = 'CLEAR_BOTS_STORE'
export const GET_ALL_DATA_BOT_CONFIGURATION = 'GET_ALL_DATA_BOT_CONFIGURATION'
export const IS_PLAY_SOUND = 'IS_PLAY_SOUND'

const state = {
  selectedBot: {},
  isPlaySound: false
}

const getters = {
  getterSelectedBot: (state) => state.selectedBot,
  getterIsPlaySound: (state) => state.isPlaySound
}

const mutations = {
  [GET_ALL_DATA_BOT_CONFIGURATION] (state, bot) {
    if (Object.keys(bot).length > 0) {
      state.selectedBot = bot
    } else {
      state.selectedBot = {}
    }
  },
  [CLEAR_BOTS_STORE] (state) {
    state.selectedBot = {}
  },
  [IS_PLAY_SOUND] (state) {
    state.isPlaySound = true
    const time = setTimeout(() => {
      state.isPlaySound = false
      clearTimeout(time)
    }, 100)
  }
}

const actions = {
  actionGetAllDataBotConfiguration ({ commit }, idBot) {
    return channelsApi.getAllDataBotConfiguration(idBot)
      .then((response) => {
        const user = {
          name: response.data.botName,
          urlImg: response.data.botLogo || '/img/icon-bot.svg',
          description: response.data.botDescription,
          color: response.data.color || '#206893',
          companyLogo: response.data.companyLogo,
          writingText: response.data.writingText
        }
        commit('$mutationInfoUser', user)
        commit(GET_ALL_DATA_BOT_CONFIGURATION, { ...response.data, botId: idBot })
        return Promise.resolve(response)
      })
      .catch((e) => Promise.reject(e))
  },
  actionGetLocalStorageAllBots () {
    const bots = localStorage.getItem(localforageKeys.ALL_BOTS('localforage/'))

    if (bots) {
      return JSON.parse(bots)
    }

    return []
  },
  actionSetLocalStorageAllBots (_, list) {
    return localStorage.setItem(localforageKeys.ALL_BOTS('localforage/'), JSON.stringify(list))
  }
}

export default {
  state,
  getters,
  actions,
  mutations
}
